/**
 * Normalises a Pusher payload. Pusher 8.x auto-parses JSON bodies before invoking
 * the bound callback, so `data` is already an object for JSON events — but older
 * publishers that emit empty strings or raw (non-JSON) strings still arrive as
 * strings. Parse only when we actually have a non-empty string, and fall back to
 * the raw string for anything that fails to parse.
 *
 * Not re-exported from the services barrel — keeps `@xmedical/core`'s public
 * surface focused on services. The WebSocketService is the only intended
 * consumer; its spec imports directly from this module.
 */
export function parsePusherPayload(data: unknown): unknown {
  if (typeof data !== 'string') return data;
  if (data.length === 0) return data;
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
}
